import { isEqual } from 'lodash';
import * as React from 'react';
import { debounce } from '../../../../utilities/helper-fuctions';
import { RequestManager } from '../../../../utilities/request';
import { Select } from './select';

export class SearchableSelect extends React.Component<any, any> {
    public select$: any;
    public isMounted = false;

    public state = {
        content: [],
        loading: false,
        error: false,

        options: false,
        searchValue: '',
    };

    public componentDidMount() {
        this.isMounted = true;

        if (this.isLocalContent()) {
            this.initializeOptions(this.filterLocalContent());
            return;
        }

        if (this.props?.isFirst) {
            this.fetch({ [this.props.param || 'query']: this.getOriginalSearchValue() });
        } else {
            const value = this.props?.field?.newValue;

            if (value != null && typeof value !== 'object' && this.props.value) {
                this.resolveById(value);
            } else {
                const current = this.props?.isMulti ? value : value ? [value] : [];
                this.initializeOptions(current || []);
            }
        }
    }

    public componentWillUnmount() {
        this.isMounted = false;
    }

    public componentDidUpdate(prevProps) {
        if (
            this.isLocalContent() &&
            (!isEqual(this.props?.content, prevProps?.content) ||
                !isEqual(this.props?.field?.newValue, prevProps?.field?.newValue))
        ) {
            this.initializeOptions(this.filterLocalContent(this.state?.searchValue));
        }
    }

    public isLocalContent() {
        return Array.isArray(this.props?.content);
    }

    public filterLocalContent(searchValue = '') {
        const content = this.props?.content || [];
        const minLocalSearchChars = this.props?.minLocalSearchChars || 0;

        if (minLocalSearchChars > 0 && `${searchValue}`.trim().length < minLocalSearchChars) {
            return [];
        }

        if (!searchValue) {
            return content;
        }

        const value = `${searchValue}`.toLowerCase();

        return content.filter((element) => {
            const title = this.props?.title ? element?.[this.props.title] : element;

            return `${title || ''}`.toLowerCase().includes(value);
        });
    }

    public getOriginalSearchValue() {
        const current = this.props?.field?.newValue;

        if (!current) {
            return 'a';
        }

        return this.props?.qeryValue ? current[this.props?.qeryValue] : current;
    }

    public async fetch(search) {
        try {
            if (this.isMounted) this.setState({ loading: true });

            const response = await RequestManager.get(this.props.endpoint, { ...search, size: 20 });

            if (!response) {
                throw new Error();
            }

            const content = response.content || response;
            if (this.isMounted) this.initializeOptions(content);
        } catch (err) {
            if (this.isMounted) this.initializeOptions(null, true);
        }
    }

    public async resolveById(id) {
        const resolveEndpoint = this.props.resolveEndpoint;

        if (!resolveEndpoint) {
            this.initializeOptions([]);
            return;
        }

        try {
            if (this.isMounted) this.setState({ loading: true });

            const response = await RequestManager.get(`${resolveEndpoint}/${id}`);

            if (!response) {
                throw new Error();
            }

            if (this.isMounted) this.initializeOptions([response]);
        } catch (err) {
            if (this.isMounted) this.initializeOptions([]);
        }
    }

    public initializeOptions(response, error = false) {
        if (!!error) {
            this.setState({ error: true, loading: false, options: [] });
            return;
        }

        const content = response || [];

        const formatOptions = content.map((element) => ({
            value: this.props.value ? element?.[this.props.value] : element,
            title: element?.[this.props.title],
        }));

        const currentValue = this.props?.field?.newValue;
        if (currentValue != null) {
            const hasMatch = formatOptions.some((opt) => isEqual(opt.value, currentValue));

            if (!hasMatch) {
                formatOptions.unshift({
                    value: currentValue,
                    title:
                        typeof currentValue === 'object'
                            ? currentValue?.[this.props.title] || ''
                            : String(currentValue),
                });
            }
        }

        if (this.props.notNull) {
            this.setState({ options: formatOptions, error: false, loading: false });
        } else {
            const nullOpt = { value: null, title: 'Not specified' };

            this.setState({ options: [...formatOptions, nullOpt], error: false, loading: false });
        }
    }

    public render() {
        if (!this.state?.options) {
            return null;
        }

        return (
            <Select
                {...this.props}
                onChange={(value) => this.handleChange(value)}
                loading={this.state?.loading}
                error={this.state?.error}
                options={this.state?.options}
                hasSearchInput={!!`${this.state?.searchValue || ''}`.trim()}
                searchable={true}
                fetch={(value) => this.fetch({ [this.props.param || 'query']: value })}
            />
        );
    }

    public handleChange(value) {
        if (this.isLocalContent()) {
            this.setState({ searchValue: value || '' });
            this.initializeOptions(this.filterLocalContent(value));
            return;
        }

        debounce(() => this.fetch({ [this.props.param || 'query']: value || 'a' }))();
    }
}
